import { render, staticRenderFns } from "./countUp.vue?vue&type=template&id=54eb03f6"
import script from "./countUp.vue?vue&type=script&lang=js"
export * from "./countUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports